import { __decorate } from "tslib";
import { property, query } from 'lit/decorators.js';
import { HelixFormControl } from './helix-form-control.js';
import { sameValidity } from './form-utils.js';
/**
 * Same as {@link HelixFormControl} but with `minlength` and `maxlength` attributes, When maxlength
 * is exceeded, it shows an error immediately and announces it by voiceover.
 *
 * **NOTE** It requires an input with `[part="hlx-form-control-input"]` to be rendered.
 */
export class HelixTextFormControl extends HelixFormControl {
    constructor() {
        super(...arguments);
        /** Is the form control required to be filled/checked */
        this.required = false;
    }
    get validity() {
        // maxlength prevents users from input, so tooLong is, basically, impossible to have.
        // However whe implement it, because preventing user's input is bad UX
        if (this.maxlength && this.maxlength < this.input.value.length) {
            return { ...this.input.validity, tooLong: true, valid: false };
        }
        else if (this.validation.hasCustomValidity) {
            return { ...this.input.validity, customError: true, valid: false };
        }
        return this.input.validity;
    }
    attributeChangedCallback(name, _old, value) {
        super.attributeChangedCallback(name, _old, value);
        // This is needed because input's validity flags `tooLong` and `tooShort` are controlled by
        // "dirty value" flag, which is reset when value updated programmatically, therefore we
        // can't just use .value=${this.value} in template because this will reset the flag.
        // However we still need this.value to be updated on input, because it is used in FormData
        // construction.
        if (name === 'value' && this.input) {
            this.input.value = value;
        }
    }
    focus(options) {
        this.input.focus(options);
    }
    handleInput() {
        this.value = this.input.value;
        const validity = this.validity;
        if (validity.valid || !sameValidity(validity, this.lastValidity)) {
            // hide errors immediately
            this.validation.showError = false;
            this.validation.errorText = '';
        }
        if (this.validity.tooLong) {
            // report (only) tooLong immediately
            this.reportValidity();
        }
        this.announce();
        this.emit('hlx-input');
    }
}
__decorate([
    property({ type: Boolean, reflect: true })
], HelixTextFormControl.prototype, "required", void 0);
__decorate([
    property({ type: Number, reflect: true })
], HelixTextFormControl.prototype, "minlength", void 0);
__decorate([
    property({ type: Number, reflect: true })
], HelixTextFormControl.prototype, "maxlength", void 0);
__decorate([
    query('[part="hlx-form-control-input"]')
], HelixTextFormControl.prototype, "input", void 0);
//# sourceMappingURL=helix-text-form-control.js.map